import type { CSSProperties, ReactNode } from "react";
import { computePredecessorDateblockMarginLeftPx } from "../../layout-constants";

export type DateblockThreeColumnLayoutProps = Readonly<{
  predecessors?: ReactNode;
  dateblock: ReactNode;
  successors?: ReactNode;
  /** When false, the dateblock sits flush without the predecessor pull-left margin. */
  showPredecessors?: boolean;
  dateblockMarginStyle?: CSSProperties;
  testId?: string;
}>;

/**
 * Reusable shell for the Focused View three-column layout:
 * Predecessors | DateBlock | Successors.
 *
 * Column content is injected by the parent so entity-specific link columns
 * (generic links, package links, bid planner) stay pluggable.
 */
export function DateblockThreeColumnLayout(
  props: DateblockThreeColumnLayoutProps
) {
  const {
    predecessors,
    dateblock,
    successors,
    showPredecessors = true,
    dateblockMarginStyle,
    testId = "entity-dateblock-new-interface"
  } = props;

  const resolvedDateblockMargin =
    dateblockMarginStyle ??
    (showPredecessors
      ? { marginLeft: computePredecessorDateblockMarginLeftPx() }
      : undefined);

  return (
    <div className="w-full h-full flex self-end" data-testid={testId}>
      <div className="flex min-w-max items-start pb-9">
        {predecessors}
        <div className="shrink-0" style={resolvedDateblockMargin}>
          {dateblock}
        </div>
        {successors}
      </div>
    </div>
  );
}

export default DateblockThreeColumnLayout;
